<template>
  <Modal
    v-model="visible"
    :title="userInfo.userType == 3 ? '新增回款' : '新增付款'"
    width="800"
    :mask-closable="false"
    :footer-hide="true"
    class="my-modal top"
  >
    <Form :model="formData" ref="infoFormRef" class="page-form less" :label-width="75" v-if="visible">
      <FormItem label="凭证编号" prop="voucherNo" class="form-item">
        <Input v-model="formData.voucherNo" placeholder="请输入" />
      </FormItem>

      <FormItem
        :label="userInfo.userType == 3 ? '收款日期' : '付款日期'"
        prop="payTime"
        class="form-item"
        :rules="$units.formRule.required('请选择日期', (trigger = 'change'), (type = 'date'))"
      >
        <DatePicker type="date" v-model.trim="formData.payTime" format="yyyy-MM-dd" transfer placeholder="选择日期"></DatePicker>
      </FormItem>

      <FormItem
        :label="userInfo.userType == 3 ? '回款金额' : '付款金额'"
        prop="payAmount"
        class="form-item"
        :rules="$units.formRule.required(`请输入${userInfo.userType == 3 ? '回款' : '付款'}金额`, 'change', 'number')"
      >
        <InputNumber v-model="formData.payAmount" :min="0" placeholder="请输入"></InputNumber>
      </FormItem>

      <FormItem :label="userInfo.userType == 3 ? '收款账户' : '付款账户'" prop="payAccount" class="form-item">
        <Input v-model="formData.payAccount" placeholder="请输入" />
      </FormItem>

      <FormItem label="凭证照片" prop="picUrl">
        <uploadNew v-model="formData.imgMobileArr" @change="imgUploadMobile" @remove="$set(formData, 'picUrl', '')"></uploadNew>
      </FormItem>

      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="formData.remark" placeholder="请输入" />
      </FormItem>
    </Form>

    <div class="ivu-modal-footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import filter from '@/api/filter';
import { mapState } from 'vuex';
export default {
  components: { uploadNew },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      visible: false,
      reportId: null,
      imgMobileArr: [],
      formData: {
        payAmount: null
      }
    };
  },
  methods: {
    open(reportId) {
      this.visible = true;
      this.reportId = reportId;
      this.formData = {
        payAmount: null
      };
    },

    imgUploadMobile() {
      if (this.formData.imgMobileArr && this.formData.imgMobileArr[0]) {
        this.$set(this.formData, 'picUrl', this.formData.imgMobileArr[0].path);
      }
    },

    ok() {
      this.$refs.infoFormRef.validate().then(isok => {
        if (!isok) {
          return;
        }
        let data = {};
        if (this.userInfo.userType != 3) {
          data.reportId = this.reportId;
          data.voucherNo = this.formData.voucherNo;
          data.payTime = filter.filterTime(this.formData.payTime, 'YYYY-MM-DD');
          data.payAmount = this.formData.payAmount;
          data.payAccount = this.formData.payAccount;
          data.picUrl = this.formData.picUrl;
          data.remark = this.formData.remark;
        } else {
          data.reportId = this.reportId;
          data.collectionCode = this.formData.voucherNo;
          data.collectionDate = filter.filterTime(this.formData.payTime, 'YYYY-MM-DD');
          data.collectionAmount = this.formData.payAmount;
          data.collectionAccount = this.formData.payAccount;
          data.billImages = this.formData.picUrl;
          data.remark = this.formData.remark;
        }
        this.$http({
          url: this.userInfo.userType == 3 ? '/buz/settlementReport/addCheckReturnedMoney' : '/buz/settlementPaymentVoucher/add',
          type: 'POST',
          data
        }).then(res => {
          this.visible = false;
          this.$notice.success('新增成功');
          this.$emit('success');
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
